import React from 'react';
import '../style/resume.css';
import resume from '../images/resume.pdf';

const ResumePopup = ({ showPopup, handlePopupToggle }) => {
  const pdfViewUrl = `${resume}#toolbar=0&navpanes=0`;

  return (
    <>
      <div className={`resume-overlay ${showPopup ? 'show' : ''}`} onClick={handlePopupToggle}></div>

      <div className={`resume-popup ${showPopup ? 'show' : ''}`}>
        <button className="resume-close-btn" onClick={handlePopupToggle} aria-label="Close resume">×</button>

        <div className="resume-popup-content">
          <div className="resume-pdf-section">
            <div className="resume-header">
              <h2>My Resume 📑</h2>
              <a href={resume} download="resume.pdf" className="resume-download-btn">
                Download
              </a>
            </div>
            <iframe
              title="Resume preview"
              src={pdfViewUrl}
              width="100%"
              height="100%"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ResumePopup;